import { Routes } from '@angular/router';
import { seoSegments, type CountryCode } from '@handyhand/i18n';

export function buildJobRoutes(country: CountryCode): Routes {
  const seg = seoSegments(country);

  const regionsCityRoutes = {
    path: ':region',
    children: [
      {
        path: `${seg.suffix.region}`,
        loadComponent: () =>
          import('../pages/seo/seo.component').then((c) => c.SeoComponent),
      },
      {
        path: `:city/${seg.suffix.city}`,
        loadComponent: () =>
          import('../pages/seo/seo.component').then((c) => c.SeoComponent),
      },
    ],
  };

  const hhRoutes: Routes = [
    {
      path: `:region/${seg.suffix.region}`,
      loadComponent: () =>
        import('../pages/seo/seo.component').then((c) => c.SeoComponent),
    },
    {
      path: `:region/:city/${seg.suffix.city}`,
      loadComponent: () =>
        import('../pages/seo/seo.component').then((c) => c.SeoComponent),
    },
    {
      path: `:subCategory/:region/${seg.suffix.region}`,
      loadComponent: () =>
        import('../pages/seo/seo.component').then((c) => c.SeoComponent),
    },
    {
      path: `:subCategory/:region/:city/${seg.suffix.city}`,
      loadComponent: () =>
        import('../pages/seo/seo.component').then((c) => c.SeoComponent),
    },
  ];

  // The jobs categories index (`/jobs/kategorier`) is retired — it linked 1,873
  // `/jobs` URLs of which only the `hasJobsPage` verticals still resolve, and it
  // earned nothing itself. `server.ts` 301s it to the find-work landing page
  // before Angular sees the request; the route is gone so it cannot render even
  // if that middleware is ever bypassed.
  //
  // The rest of this tree stays: the `hasJobsPage` verticals are live pages, and
  // the ungated ones need to reach `SeoComponent` for the dashboard's 301 to
  // find-work to fire.
  const jobsAndFindRoutes: Routes = [
    {
      path: ':headCategory/:subCategory',
      children: [
        {
          path: '',
          loadComponent: () =>
            import('../pages/seo/seo.component').then((c) => c.SeoComponent),
        },
        regionsCityRoutes,
      ],
    },
    {
      path: ':headCategory',
      children: [
        {
          path: '',
          loadComponent: () =>
            import('../pages/seo/seo.component').then((c) => c.SeoComponent),
        },
        regionsCityRoutes,
        ...hhRoutes,
      ],
    },
  ];

  return [
    {
      path: seg.section.jobs,
      children: jobsAndFindRoutes,
    },
  ];
}
